// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"DashboardForm_stepsNav__2l11E","navLink":"DashboardForm_navLink__21oMz","active":"DashboardForm_active__3Ir8o"};